import { memo, useEffect, useState } from "react";
import { AppPortal } from "svix-react";
import useGetOrganization from "../../api/useGetOrganization";
import useGetSvixPortal from "../../api/useGetSvixPortal";
import useThemeStore from "../../stores/useThemeStore";
import style from "./style/SvixWrapper.module.scss";
import Errors from "../Errors";

export default function SvixEmbed() {
  const theme = useThemeStore((state) => state.theme);
  const { data: organization } = useGetOrganization();
  const workspaceId = organization?.workspaces?.[0]?.id || "";
  const { isLoading, data: portal, error } = useGetSvixPortal(workspaceId);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const IframeComponent = memo(({ portalUrl }: any) => {
    return <AppPortal url={portalUrl} fullSize />;
  });

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setIframeLoaded(true);
      }, 1000);
    }
  }, [isLoading]);

  if (isLoading) {
    return null;
  }

  if (error || !portal?.url) {
    return <Errors error={error} />;
  }

  let portalUrl = portal?.url;
  if (theme === "dark") portalUrl = addUrlParameter(portalUrl, "darkMode", "true");

  return (
    <>
      {!iframeLoaded && <div className={style.svixEmbed}>Loading...</div>}
      {iframeLoaded && (
        <div className={style.svixEmbed}>
          <div className={!iframeLoaded ? style.hidden : ""}>
            <IframeComponent portalUrl={portalUrl} />
          </div>
        </div>
      )}
    </>
  );
}

const addUrlParameter = (url: string, key: string, value: string): string => {
  if (!url) {
    return url;
  }
  try {
    let urlObject = new URL(url);
    urlObject.searchParams.append(key, value);
    return urlObject.toString();
  } catch {
    return url;
  }
};
